export default __webpack_public_path__ + "static/media/template_business-man__0004_23---BillPerk.614ea61c.png";